<template>
    <div id="app" ondragstart="return false">
        <!-- 全局禁止拖拽 -->
        <router-view/>
    </div>
</template>


<script>
export default {
    name: "app",
    components: {},
    created() {
    },
    mounted() {
    }
};
</script>

<style lang="scss">
#app {
    font-family: Arial, "Helvetica Neue", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Helvetica, Verdana, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
</style>
